<template>
  <v-container>
    <!-- <faq-filter @getData="getData" class=""></faq-filter> -->

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      hide-default-footer
      disable-pagination
      :loading="loading"
      :loading-text="'لطفا صبور باشید'"
    >
      <template v-slot:[`item.operation`]="{ item }">
        
        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                @click="navToEdit(item)"
                >
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-lead-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>ویرایش</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="error" @click="deleteItem(item)"
              ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
            >
              </template>
              <span>حذف</span>
            </v-tooltip>
      </template>
      <template v-slot:[`item.sortOrder`]="{ item }">
          <span class="text-truncate maxw--3 d-block">
            {{item.sortOrder}}

            </span>
      </template>
      <template v-slot:[`item.disabled`]="{ item }">
        <v-switch
          @click="changeStatus(item)"
          dense
          :label="item.disabled ? 'غیر فعال' : 'فعال'"
          v-model="item.disabled"
          :false-value="true"
          :true-value="false"
        ></v-switch>
      </template>
      <template v-slot:[`item.answer`]="{ item }">
          <span class="text-truncate maxw--3 d-block">
            {{item.answer.length>50?item.answer.slice(0,50)+'...':item.answer}}

            </span>
      </template>
      <template v-slot:[`item.question`]="{ item }">
          <span class="text-truncate maxw--3 d-block">
             {{item.question.length>30?item.question.slice(0,30)+'...':item.question}}
            </span>
      </template>
    </v-data-table>
    <div class="text-center mt-8">
    <v-row>
      <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>
        <!-- <v-spacer/> -->
      <v-col cols="12" sm="10" md="10">
      <v-pagination
        circle
        v-model="pageNumber"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
       <!-- <v-spacer/> -->
    </v-col>
    </v-row>
    </div>
  </v-container>
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const faqRepository = () => RepoFactory.get("faqPage");
import Helper from "@/core/helpers";
import FaqFilter from "./FaqFilter";

export default {
  name: "frequently-asked-questions",
  components:{FaqFilter},
  data() {
    return {
      pageNumber: 1,
      pageCount: 10,
      loading: true,
      items: [],
      showDeleteDialog: false,
      itemsPerPage:10,
      editMode:false
    };
  },
  computed: {
    headers() {
      return [
        { text: 'ردیف', value: "sortOrder" },
        { text: 'سوال', value: "question" },
        { text: 'پاسخ', value: "answer" },
        { text: 'وضعیت', value: "disabled" },
        { text: 'عملیات', value: "operation" },
      ];
    },
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    merchantId(){
      return this.$store.getters.currentMerchant;

    }
  },
  watch: {
    merchantId(after){
      if(after) this.getData()
    },
    pageNumber() {
      this.getData();
    },
    itemsPerPage(){
      this.getData();
    }
  },
  methods: {
    getFAQByFilterParams(filter){
      if(filter.key == null && filter.merchantId == null && filter.contentTypeId == null && filter.includePageBody == null && filter.includeMerchantPages == null && filter.disabled == null  ){
        this.fetchPagesItems()
      }
      else{
        this.pagesItems = [];
        let params = filter

        const loader = this.$loading.show()
        faqRepository()
          .getPagesWithFilter(
            this.baseUrl,
            {
              MerchantId : this.$store.getters.currentMerchant
            },
            params,
          )
        .then((res) => {
          if (res.data && res.data.length) {
            this.$store.commit("setPagesCurrentList", res.data);
            this.pagesItems = res.data;
            this.totalCount = res.data.length;
            this.pageCount=1
          } 
          else {
            this.$store.commit("setPagesCurrentList", []);
            this.pagesItems = [];
            this.totalCount = 1;
          }
            this.loadingPagesTable = false;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(()=> loader.hide())
    }
    },
    changeStatus(item) {
      
      const loader = this.$loading.show();
      if (item.disabled) {
       //غیر فعال کردن
         faqRepository()
        .disableFaqquestions(item.id, this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant
        }
        ).then(res => {
          this.$dialog.message.success("با موفقیت غیرفعال شد", {
            position: "top-left"
          });
            loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
            loader.hide()
        });
     }else{
       //فعال کردن
         faqRepository()
        .enableFaqquestions(item.id, this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant

               }
        ).then(res => {
          this.$dialog.message.success("با موفقیت فعال شد", {
            position: "top-left"
          });
            loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
            loader.hide()
        });
     }
    },
    deleteItem(item) {
      let app =this
      this.$dialog.warning({
        text: ` آیا از حذف این آیتم اطمینان دارید؟`,
        title: "هشدار",
        actions: {
          false: {
            color: "red",
            text: "خیر",
          },
          true: {
            color: "primary",
            text: "بله",
            handle: () => {
              const loader = this.$loading.show();
              faqRepository()
                .deleteFaqquestions(item.id, this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant

                })
                .then(() => {
                  // this.getData();
                  
                  app.items.splice( app.items.map(e=>e.id).indexOf(item.id),1)

                   this.$dialog.message.success("با موفقیت حذف گردید", {
                    position: "top-left",
                  });
                  loader.hide();
                })
                .catch((error) => {
                  console.log('catch', error);
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
    editItem(body){
       const loader =this.$loading.show();
            this.faqquestionsObject.pageTitle = null;
          faqRepository()
            .updateFaqquestions(
              this.$store.getters.setFaqSelectedForEdit.id,
              body,
              this.baseUrl,
              {
                MerchantId : this.$store.getters.currentMerchant
              }
            )
            .then(res => {
              this.$dialog.message.success("با موفقیت ویرایش شد", {
                position: "top-left"
              });
              loader.hide()
               this.$store.commit("setFaqSelectedForEdit", null);
                this.$store.commit("setFaqIsEdit", false);
                this.$store.commit("setFaqFormStatus", false);
            })
            .catch(error => {
              Helper.handleErrors(error, this);
              loader.hide()
            });
    },
    navToEdit(item) {
      this.$store.commit("setFaqSelectedForEdit", item);
      this.$store.commit("setFaqIsEdit", true);
      this.$store.commit("setFaqFormStatus", true);
    },
    navToCreate() {
        this.$store.commit("setFaqFormStatus", true);
    },
    getData(filter) {
        const loader =this.$loading.show();
        this.loading = true;
        let params = {
          PageNumber: this.pageNumber,
          ItemsPerPage: this.itemsPerPage,
          question : filter && filter.question? filter.question : null,
          faqCategoryId : filter && filter.faqCategoryId? filter.faqCategoryId : null
        };
        faqRepository()
          .getFaqquestions(
            this.baseUrl,
            {
             MerchantId : this.$store.getters.currentMerchant
            },
            params
          )
        .then((res) => {
         
          if(res.data){
            this.items = res.data.list;
            this.pageCount = Math.ceil(Number(res.data.totalCount) / this.itemsPerPage);
            this.loading = false;
            this.$store.commit('setFaqTableItems', res.data.list)
            this.$store.commit('setFaqPageCount', res.data.totalCount)
          }
          else{
            this.items = []
            this.pageCount = 1
            this.loading =false
            this.$store.commit('setFaqTableItems', [])
            this.$store.commit('setFaqPageCount', 0)
          }
          loader.hide()
        })
        .catch((err) => {
          this.loading = false;
          loader.hide()
        });

    }
    
  },
  created() {
    if(this.merchantId) this.getData();
   
  },
};
</script>

<style scoped></style>
